import { render, staticRenderFns } from "./SponsorActivation.view.vue?vue&type=template&id=02b52b76"
import script from "./SponsorActivation.view.vue?vue&type=script&lang=js"
export * from "./SponsorActivation.view.vue?vue&type=script&lang=js"
import style0 from "./SponsorActivation.view.vue?vue&type=style&index=0&id=02b52b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports